import { CommonModule } from '@angular/common';
import { Component,
  computed,
  model } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';

import { SideTabItemModel } from '../../models/tab.model';
import { InlineSvgComponent } from '../inline-svg/inline-svg.component';

@Component({
  selector: 'ui-side-tabs',
  imports: [ CommonModule, InlineSvgComponent, TranslocoModule ],
  templateUrl: './side-tabs.component.html',
  styleUrl: './side-tabs.component.scss',
})
export class SideTabsComponent {
  tabs = model<SideTabItemModel[]>();
  openTabs = computed(() => this.tabs()?.some(v => v.selected));

  /** A method that switches to the selected tab. */
  switchTab(value: SideTabItemModel): void {
    this.tabs.update((tab) =>
      tab?.map((item) => ({
        ...item,
        selected: item === value,
      }))
    );
  }

  onShowHideTabs(): void {
    if (this.tabs() && this.openTabs()) {
      this.tabs.update(tabs =>
        tabs?.map(tab => ({
          ...tab,
          selected: false,
        }))
      );
    } else {
      this.tabs.update(tabs =>
        tabs?.map((tab, index) => ({
          ...tab,
          selected: index === 0,
        }))
      );
    }
  }
}
